var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2 8.99995C16.2 12.4793 12.9765 15.3 9.00005 15.3C7.65758 15.3 6.40092 14.9785 5.32514 14.4187L1.80005 15.3L3.00452 12.4895C2.24357 11.4905 1.80005 10.2906 1.80005 8.99995C1.80005 5.52056 5.0236 2.69995 9.00005 2.69995C12.9765 2.69995 16.2 5.52056 16.2 8.99995ZM6.30005 8.09995H4.50005V9.89995H6.30005V8.09995ZM13.5 8.09995H11.7V9.89995H13.5V8.09995ZM8.10005 8.09995H9.90005V9.89995H8.10005V8.09995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.4a60cca8360b84125a7e23ae5b46801c.svg";
export { ForwardRef as ReactComponent };